module.exports = __webpack_public_path__ + "51484c9f4ab4d93be1a50b0743bcdd5b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/year-in-review/2017/icons/community-energy-gradient.png
// module id = 1864
// module chunks = 1